import {useEffect, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';


import {RegisterInvoiceService} from '../../../service/invoice/RegisterInvoiceService';
import {InvoiceService as Service, InvoiceService} from '../InvoiceService';

import {useForm} from '../../../shared/hooks/Form';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {FormatDisplay} from '../../../shared/format';
import  EventEmitter  from '../../../utils/EventEmitter';

export const DialogSignInvoice = (props) => {
  const {display, setDisplay, addSelectedItems, selectionMode, invoiceStatus, sendTaxStatus, registerInvoice} = props;
  const [invoiceSerials, setInvoiceSerials] = useState([]);
  const [perPageOptions, setPerPageOptions ]= useState([50, 100, 200,300]);
  
  const [requiredParams, setRequiredParams] = useState(null);

  useEffect(() => {
    RegisterInvoiceService.getUsingList({maxResultCount: 1000}).then(({items}) => {
      const _invoiceSerials = [];
      items.forEach(item => {
        _invoiceSerials.push({value: item.symbolCode, label: item.symbolCode});
      });
      setInvoiceSerials(_invoiceSerials);
    });    
   
  }, []);

  const {render: renderForm, setValue, getValue} = useForm({
    fields: [
      {field: 'invoiceSerial', required: true, header: 'Ký hiệu', type: 'Dropdown', DropdownProps: {options: invoiceSerials, filter: true, resetFilterOnHide: true}, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'fromDate', header: 'Từ ngày', type: 'Calendar', className: 'md:col-3', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8'},
      {field: 'toDate', header: 'Đến ngày', type: 'Calendar', className: 'md:col-3', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8'},
    ],
    layout: 'Horizontal'
  });

  const search = () => {
    const searchValue = getValue();
    if (invoiceStatus) {
      searchValue.invoiceStatus = invoiceStatus;
    }
    if (sendTaxStatus) {
      searchValue.sendTaxStatus = sendTaxStatus;
    }
    setRequiredParams(searchValue);
  }

  const {render: renderDataTable, refreshLazyData, selectedItems, clearItems} = useDataTable({
    header: '',
    dataKey: 'id',
    columns: [
      {
        field: 'invoiceStatus', header: 'Trạng thái', width: 110, matchMode: 'contains', filterType: 'dropdown', filterOptions: Service.invoiceStatuses, dataType: 'custom', customCell(rowData: any): any {
          return <span className={`invoice-status invoice-status-${rowData.invoiceStatus}`}>{Service.invoiceStatuses[rowData.invoiceStatus]?.label}</span>;
        }
      },
      {field: 'invoiceSerial', header: 'Ký hiệu', width: 100, matchMode: 'contains'},
      {field: 'invoiceDate', header: 'Ngày hoá đơn', width: 110, dataType: 'date'},
      {field: 'invoiceNumber', header: 'Số hoá đơn', width: 110, matchMode: 'contains'},
      {
        field: 'buyerLegalName', header: 'Tên đơn vị/Tên người mua', minWidth: 250, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return rowData.buyerLegalName || rowData.buyerDisplayName;
        }
      },
      {field: 'buyerTaxCode', header: 'Mã số thuế', width: 110, matchMode: 'contains'},
      {
        field: 'totalAmount', header: 'Tổng tiền thanh toán',matchMode: 'contains', width: 160, dataType: 'custom', customCell(rowData: any): any {
          return FormatDisplay.number(rowData['totalAmount'] || 0, FormatDisplay.getFractionDigits(rowData));
        }, style: {justifyContent: 'end'}
      },
    ],
    heightCalc: 350,
    requiredParams,
    getList: (params) => {
      return InvoiceService.getListInvoiceSign(params);
    },
    selectionMode,
    perPageOptions
  });

  useEffect(() => {
    if (display) {
      setValue({
        invoiceSerial: registerInvoice.symbolCode,
        fromDate: null,
        toDate: null
      });
      clearItems();
    }
  }, [display]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = () => {    
    addSelectedItems(selectedItems);
  }

useEffect(() => {
    const reloadData = () => {
      refreshLazyData();
      clearItems();
    }
    const eventsListner = EventEmitter.addListener("reloadSearchInvoiceSign", reloadData);
    return () => {
      eventsListner.removeListener("reloadSearchInvoiceSign", reloadData)
    }
  })


  return (
    <Dialog header="Chọn hoá đơn" visible={display} style={{width: '90rem'}}  draggable={false} resizable={true} position="top"
            onHide={() => setDisplay(false)}>
      <div className="grid">
        <div className="col-11">
          {renderForm()}
        </div>
        <div className="col-1">
          <Button icon="pi pi-search" className="p-button-rounded p-button-outlined" onClick={search}/>
        </div>
        <div className="col-12">
          {renderDataTable()}
        </div>
      </div>

      <div className="flex justify-content-end">
        <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-text p-button-sm"/>
        <Button label="Ký gửi CQT" icon="pi pi-user-edit" onClick={handleSubmit} className="p-button-sm"/>
      </div>
    </Dialog>
  );
}